module.exports = __webpack_public_path__ + "static/media/Ki.34533d80.svg";